/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum QiraEventKind {
  Value320000 = 320000,
  Value500000 = 500000,
  Value600000 = 600000,
  Value600001 = 600001,
  Value600002 = 600002,
  Value700000 = 700000,
  Value100000 = 100000,
  Value300000 = 300000,
  Value300100 = 300100,
  Value300200 = 300200,
  Value300210 = 300210,
  Value300220 = 300220,
  Value340000 = 340000,
  Value300300 = 300300,
  Value330000 = 330000,
  Value310000 = 310000,
  Value310010 = 310010,
  Value210000 = 210000,
  Value211000 = 211000,
  Value212000 = 212000,
  Value212010 = 212010,
  Value220000 = 220000,
  Value400100 = 400100,
  Value400200 = 400200,
  Value410000 = 410000,
}

export enum SubscriptionPlan {
  Trial = "trial",
  Professional = "professional",
  Enterprise = "enterprise",
}

export interface AheadUser {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  user_type?: string;
  state?: string;
  created_at?: string;
  updated_at?: string;
  company_id: string;
  phone_number?: string | null;
  salutation?: string | null;
  roles?: string[];
  default_scope?: string;
}

export interface AheadCompany {
  id: string;
  created_at?: string;
  updated_at?: string;
  num_of_employees?: number | null;
  num_of_platforms?: number | null;
  qira_joined_at?: string | null;
  country_code?: string | null;
  qira?: boolean | null;
  propoints?: boolean | null;
  partner_code?: string | null;
  name: string;
  vat_number?: string | null;
  address_line_1?: string | null;
  address_line_2?: string | null;
  city?: string | null;
  zip?: string | null;
}

export interface UserSubscriptionData {
  /** MongoDB ObjectId as string */
  _id: string;
  /**
   * The subscription plan type
   * @example "trial"
   */
  plan: SubscriptionPlan;
  companyId: string;
  stripeCustomerId: string | null;
  /** @format date-time */
  trialStart: string;
  /** @format date-time */
  trialEnd: string;
  /** @format date-time */
  subStart: string | null;
  /** @format date-time */
  endOfSub: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface QiraUserBE {
  userId: string;
  codeId?: string;
  profile: AheadUser;
  company: AheadCompany;
  subscription: UserSubscriptionData;
  qiraRole: "ADMIN" | "DEVICE";
  isAdmin?: boolean;
}

export interface UpdateCompanyDto {
  address_line_1?: string | null;
  address_line_2?: string | null;
  zip?: string | null;
  city?: string | null;
  name?: string | null;
  vat_number?: string | null;
  num_of_employees?: number | null;
  num_of_platforms?: number | null;
  partner_code?: string | null;
}

export interface UpdateUserDto {
  first_name?: string;
  last_name?: string;
  user_type?: string;
  state?: string;
  created_at?: string;
  updated_at?: string;
  phone_number?: string | null;
  company?: UpdateCompanyDto;
  salutation?: string;
}

export interface GenerateCodeDto {
  note?: string;
}

export interface UserCode {
  _id: string;
  code: string;
  note?: string;
  ownerUserId: string;
  isActive: boolean;
  isDeactivated: boolean;
  isLoggedOut: boolean;
  isHidden: boolean;
  usedAt?: string;
  usedByDevice?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface LoginWithCodeDto {
  code: string;
}

export interface LoginWithCodeResponseDto {
  success: boolean;
}

export interface DeactivateCodeDto {
  id: string;
}

export interface HideCodeDto {
  id: string;
}

export type Object = object;

export interface HgsArticleOld {
  text: string;
  data?: object;
}

export interface HgsManufacturer {
  id: number;
  name: string;
}

export interface HgsDrivetrain {
  engineCode: string;
  engineHp: number;
  engineKw: number;
  propulsionType: string;
  propulsionTypeName: string;
  cylinders: number;
}

export interface HgsModel {
  modelId: number;
  modelType: string;
  engineSize: number;
  modelSeriesName: string;
  modelName: string;
  typeOfVehicle: string;
  regionCode: string;
  fromYear: number;
  toYear: number;
  electronicOEServiceRegistrationTId: number;
}

export interface HgsVehicleType {
  kTypeNo: number;
}

export interface VehicleReference {
  hgs: {
    manufacturer: HgsManufacturer;
    drivetrain: HgsDrivetrain;
    model: HgsModel;
  };
  tecDoc: {
    vehicleType: HgsVehicleType;
  };
}

export interface Translation {
  language: string;
  title?: string;
  text?: string;
  systemName?: string;
}

export interface CompartmentComponent {
  componentId: string;
  shortName: string;
  name: Translation;
  group: Translation;
  imageUrl: string;
  placementText?: Translation;
  genericArticleNos: number[];
  showInComponentList: boolean;
  xAbs: string;
  yAbs: string;
}

export interface CompartmentSystem {
  systemId: string;
  systemName: Translation;
  dateFrom?: string;
  dateTo?: string;
  imagePlacementUrl: string;
  components: CompartmentComponent[];
}

export interface Compartment {
  systems: CompartmentSystem[];
}

export interface ComponentLocation {
  vehicleReference: VehicleReference;
  engineCompartment: Compartment;
}

export interface ComponentGroup {
  language: string;
  title: string;
}

export interface ComponentText {
  language: string;
  title: string;
}

export interface DiagramComponent {
  type: string;
  id: string;
  shortName: string;
  showInComponentList: boolean;
  genericArticleNumbers: number[];
  group: ComponentGroup;
  text: ComponentText;
}

export interface ComponentCoordinate {
  component: DiagramComponent;
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

export interface FuseBoxDocument {
  title: string;
  /** @default null */
  imageUrl: string | null;
  name: string;
  componentCoordinates: ComponentCoordinate[];
}

export interface WiringDiagram {
  title: string;
  imageUrl: string | null;
  componentCoordinates: ComponentCoordinate[];
}

export interface ValueItem {
  id: string;
  value: string;
  notes?: string[];
  imageUrls?: string[];
}

export interface StepItem {
  order: number;
  sequence?: string;
  text: string;
  imageUrls: string[];
  notes?: string[];
}

export interface TechDataColumnHeader {
  columnId: string;
  columnNumber: string;
  allowedDeviation: string;
}

export interface TechDataTableCell {
  id: number;
  columnNumber: number;
  textValue: string;
}

export interface TechDataTableRow {
  rowNumber: number;
  cells: TechDataTableCell[];
}

export interface TableData {
  id: string;
  columnHeaders: TechDataColumnHeader[];
  rows: TechDataTableRow[];
}

export interface GuideTranslation {
  language: string;
  title: string;
}

export interface GuideTextReference {
  id: number;
  translations: GuideTranslation;
}

export interface GuideStepTitle {
  textReference: GuideTextReference;
}

export interface GuideObjectReference {
  type: string;
  id: string;
}

export interface GuideIcon {
  order: number;
  objectReference: GuideObjectReference;
  fileExtension: string;
}

export interface GuideLine {
  id: number;
  order: number;
  textReference: GuideTextReference;
  isListItem: boolean;
}

export interface GuideImage {
  order: number;
  objectReference: GuideObjectReference;
}

export interface GuideStep {
  id: number;
  type: string;
  order: number;
  title: GuideStepTitle;
  icon: GuideIcon | null;
  lines: GuideLine[];
  images: GuideImage[];
}

export interface Guide {
  id: string;
  title: string | null;
  guideSteps: GuideStep[];
}

export interface GenericArticleText {
  language: string;
  title: string;
}

export interface GenericArticleInformation {
  genArtNos: number[];
  text: GenericArticleText;
  defaultAmount: number;
}

export interface TechDataItemData {
  values?: ValueItem[];
  steps?: StepItem[];
  hasMultipleSequences?: boolean;
  sequences?: string[];
  table?: TableData;
  criteria?: {
    id: string;
    name: string;
  };
  variant?: {
    id: string;
    name: string;
  };
  guideIds?: string[];
  guides?: Guide[];
  genericArticleInformation?: GenericArticleInformation[];
}

export interface TechDataItem {
  id: string;
  groupId: string;
  groupText: string;
  groupPath: string[];
  parentGroup?: {
    id: string;
    text: string;
  };
  type: object;
  data: TechDataItemData;
  markdown: string;
}

export interface RecallItem {
  headline: string;
  text: string;
  classification: string;
  validFrom: string;
  validTo: string;
  kindOfVehicleTreeId: string;
}

export interface RepairInstructionsDocument {
  manualId: number;
  title: string;
  subtitle: string;
}

export interface RepairTimesJob {
  calcMode: object;
  code: string;
  name: string;
  variantCode: object;
  variantText: string;
  genericArticleNo: number[];
}

export interface RepairTimesAssociatedWork {
  order: number;
  display: boolean;
  repairTime: number;
  calculation: object;
  job: RepairTimesJob;
}

export interface RepairTimesLinkCriteria {
  criteria: string;
  criteriaValue: string;
}

export interface RepairTimesJobLinkDetails {
  id: number;
  hint: string;
  order: number;
  totalRepairTime: number;
  associatedWorks: RepairTimesAssociatedWork[];
  linkCriteria: RepairTimesLinkCriteria;
}

export interface RepairTimesJobLinkOther {
  order: number;
  link: RepairTimesJobLinkDetails;
}

export interface RepairTimesJobLink {
  jobLink: RepairTimesJobLinkDetails;
  preliminaryLinks: RepairTimesJobLinkOther[];
  subsequentLinks: RepairTimesJobLinkOther[];
  notIncludedLinks: RepairTimesJobLinkOther[];
}

export interface RepairTime {
  category: string;
  subCategory: string;
  code: string;
  id: number;
  variantCode: object;
  variantText: string;
  name: string;
  genericArticleNo: number[];
  calcMode: object;
  jobLinks: RepairTimesJobLink[];
}

export interface RepairTimesDetails {
  category: string;
  subCategory: string;
  repairTimes: RepairTime[];
}

export interface DocumentParameters {
  type: string;
  carTypeId?: number;
  carTypeGroup?:
    | "ENGINE"
    | "TRANSMISSION"
    | "STEERING"
    | "BRAKES"
    | "EXTERIOR"
    | "ELECTRONICS"
    | "QUICKGUIDES";
  location?: 5 | 4 | 1 | 2 | 3 | 6;
  storyId?: number;
  tsbType?: string;
  systemId?: number;
  errorCode?: string;
  vin?: string;
  engineCode?: string;
  mbId?: number;
  mbNumber?: string;
  mbInfoTypeCode?: number;
  daily?: boolean;
  managementSystemId?: number;
  componentId?: number;
  systemName?: string;
  componentName?: string;
  level?: object;
  systemGroupId?: number;
  systemGroupName?: string;
  systems?: object[];
  components?: object[];
  chapterId?: string;
  mainChapterId?: string;
  xmlDocumentId?: string;
  repairGroupNumber?: string;
  elasticsearchId?: string;
  wdGroupNumber?: string;
  guid?: string;
  hgsDocumentId?: string;
  documentText?: string;
  hgsSystemId?: string;
  language?: string;
  docTitle?: string;
  kType?: string;
  hgsComponentId?: string;
  techDataGroupId?: string;
  recallHeadline?: string;
  country?: string;
  hgsServiceScheduleId?: number;
  parentGroupId?: string;
  parentGroupText?: string;
  grandParentGroupId?: string;
  grandParentGroupText?: string;
  mainGroupId?: string;
  subGroupId?: string;
  manualGroupId?: string;
  manualId?: string;
  qualifierId?: string;
  categoryId?: string;
  subCategoryId?: string;
  genericArticleNo?: string;
  searchTerm?: string;
}

export interface SearchEntry {
  text: string;
  previewText?: string;
  tags: string[];
  provider:
    | "static"
    | "haynespro"
    | "mercedes"
    | "volkswagen"
    | "skoda"
    | "seat"
    | "audi"
    | "tesla"
    | "hgs"
    | "qiradb"
    | "varta";
  subject:
    | "Lubricants"
    | "Adjustments"
    | "MaintenancePeriods"
    | "MaintenanceProcesses"
    | "MaintenanceForms"
    | "MaintenanceServiceResets"
    | "EOBDLocations"
    | "FuseLocations"
    | "EngineLocations"
    | "Locations"
    | "ControlUnitLocations"
    | "GroundingPointLocations"
    | "HVACLocations"
    | "RepairManuals"
    | "WarningLights"
    | "TechnicalDrawings"
    | "TechData"
    | "SmartCases"
    | "Recalls"
    | "Bulletins"
    | "ErrorCode"
    | "WiringDiagrams"
    | "FuseBoxes"
    | "RepairInstructions"
    | "RepairTimes"
    | "Battery"
    | "Default";
  parameters: DocumentParameters;
  id: string;
}

export interface InspectionItemInfo {
  name: string;
  operation: string;
  aggregatedLabourTime: number;
}

export interface InspectionInfo {
  name: string;
  icon: string;
  items: InspectionItemInfo[];
}

export interface InspectionDocument {
  title: string;
  inspections: InspectionInfo[];
  components: string[];
}

export interface HgsData {
  componentLocation?: ComponentLocation;
  fuseBoxDocument?: FuseBoxDocument;
  wiringDiagram?: WiringDiagram;
  techDataItem?: TechDataItem;
  recallItem?: RecallItem;
  repairInstructions?: RepairInstructionsDocument;
  repairTimesDetails?: RepairTimesDetails;
  serviceSchedules?: SearchEntry[];
  inspectionDocument?: InspectionDocument;
}

export interface HgsArticle {
  text: string;
  data?: HgsData;
}

export interface Manufacturer {
  id: number;
  name: string;
}

export interface ModelDetails {
  yearOfConstrFrom?: number;
  yearOfConstrTo?: number;
}

export interface Model {
  id: number;
  name: string;
  details: ModelDetails;
  displayString?: string;
}

export interface VehicleIdentifier {
  carTypeId?: number;
  kTypeIdTecDoc?: number | null;
}

export interface Vehicle {
  id: VehicleIdentifier;
  name: string;
  madeFrom?: string | null;
  madeUntil?: string | null;
  engineCode?: string | null;
  fuelType?: string[] | null;
  capacity?: number | null;
  output?: number | null;
  tonnage?: number | null;
  image?: string | null;
  subjectsByGroup?: {
    mapItems: object[];
  };
  tecDocPrototypes?: string[];
}

export interface HpWSCriteriaValue {
  id: string | null;
  value: string | null;
}

export interface HpWSCriteria {
  dataType: string | null;
  description: string | null;
  id: string | null;
  values: HpWSCriteriaValue[] | null;
}

export interface HpStatus {
  statusCode: number;
  confirmationLink: string | null;
}

export interface HpWSIdentificationElement {
  id: number | null;
  level: object | null;
  order: number | null;
  name: string | null;
  fullName: string | null;
  madeFrom: string | null;
  madeUntil: string | null;
  engineCode: string | null;
  fuelType: object[] | null;
  capacity: number | null;
  output: number | null;
  tonnage: number | null;
  image: string | null;
  superElementId: number | null;
  superElementLevel: object;
  subjects: object[] | null;
  subjectsByGroup: {
    mapItems: object[];
  };
  criteria: HpWSCriteria[] | null;
  subElements: HpWSIdentificationElement[] | null;
  status: HpStatus | null;
}

export interface CatalogueIdentification {
  make: Manufacturer;
  model: Model;
}

export interface VehicleIdentification {
  vin?: string;
  kba?: string;
  catalogue?: CatalogueIdentification;
  engineCode?: string;
  id: VehicleIdentifier;
}

export interface CreateThreadDto {
  title: string;
  vehicleIdentification: VehicleIdentification;
  testing?: boolean;
}

export interface ComponentData {
  systemId: string;
  systemName: string;
  componentId: string;
  componentName: string;
}

export interface SystemGroupData {
  systemGroupId?: number;
  systemGroupName: string;
  componentData: ComponentData[];
}

export interface ChatWidgetParameters {
  carTypeId?: number;
  errorCode?: string;
  mode?: string;
  systemGroups?: SystemGroupData[];
  components?: ComponentData[];
}

export interface ChatWidget {
  id: "component-wiring-diagram" | "guided-diagnosis";
  name?: string;
  endpoint?: string;
  parameters?: ChatWidgetParameters;
}

export interface SourceDetails {
  documentParameters?: DocumentParameters;
  errorCode?: string;
  originalURL?: string;
}

export interface Source {
  provider:
    | "static"
    | "haynespro"
    | "mercedes"
    | "volkswagen"
    | "skoda"
    | "seat"
    | "audi"
    | "tesla"
    | "hgs"
    | "qiradb"
    | "varta";
  subject:
    | "Lubricants"
    | "Adjustments"
    | "MaintenancePeriods"
    | "MaintenanceProcesses"
    | "MaintenanceForms"
    | "MaintenanceServiceResets"
    | "EOBDLocations"
    | "FuseLocations"
    | "EngineLocations"
    | "Locations"
    | "ControlUnitLocations"
    | "GroundingPointLocations"
    | "HVACLocations"
    | "RepairManuals"
    | "WarningLights"
    | "TechnicalDrawings"
    | "TechData"
    | "SmartCases"
    | "Recalls"
    | "Bulletins"
    | "ErrorCode"
    | "WiringDiagrams"
    | "FuseBoxes"
    | "RepairInstructions"
    | "RepairTimes"
    | "Battery"
    | "Default";
  title?: string;
  details: SourceDetails;
}

export interface QiraMessageContentChunk {
  provider:
    | "static"
    | "haynespro"
    | "mercedes"
    | "volkswagen"
    | "skoda"
    | "seat"
    | "audi"
    | "tesla"
    | "hgs"
    | "qiradb"
    | "varta";
  text?: string;
  answerType?: object;
  document?: {
    previewText: string;
    parameters: DocumentParameters;
    subject:
      | "Lubricants"
      | "Adjustments"
      | "MaintenancePeriods"
      | "MaintenanceProcesses"
      | "MaintenanceForms"
      | "MaintenanceServiceResets"
      | "EOBDLocations"
      | "FuseLocations"
      | "EngineLocations"
      | "Locations"
      | "ControlUnitLocations"
      | "GroundingPointLocations"
      | "HVACLocations"
      | "RepairManuals"
      | "WarningLights"
      | "TechnicalDrawings"
      | "TechData"
      | "SmartCases"
      | "Recalls"
      | "Bulletins"
      | "ErrorCode"
      | "WiringDiagrams"
      | "FuseBoxes"
      | "RepairInstructions"
      | "RepairTimes"
      | "Battery"
      | "Default";
    id: string;
    data?: object;
    cited?: boolean;
  };
  widget?: ChatWidget;
  sources?: Source[];
  errorDocument?: {
    errorCode: string;
    description: string;
  };
  intentSuggestions?: string[];
}

export interface QiraMessage {
  id: string;
  /** @format date-time */
  created_at: string;
  sender: "bot" | "you";
  type: "end" | "info" | "error" | "stream" | "feedback";
  voting?: number;
  feedback?: string;
  content: QiraMessageContentChunk[];
  toolUsage?: object[];
}

export interface ThreadSession {
  vehicle?: Vehicle;
}

export interface Thread {
  _id: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  last_updated_at: string;
  vehicleIdentification: VehicleIdentification;
  userId: string;
  title: string;
  messages: QiraMessage[];
  session: ThreadSession;
  repairTimesSearchEntries?: string;
}

export interface ThreadWithoutMessagesDto {
  _id: string;
  /** @format date-time */
  created_at: string;
  /** @format date-time */
  last_updated_at: string;
  vehicleIdentification: VehicleIdentification;
  userId: string;
  title: string;
  session: ThreadSession;
}

export interface UpdateThreadDto {
  title?: string;
  vehicleIdentification?: VehicleIdentification;
  testing?: boolean;
}

export interface CreateMessageDto {
  text: string;
  qiraSystem: object;
}

export interface UpdateMessageDto {
  voting?: number | null;
  feedback?: string | null;
}

export interface NavigationItem {
  name: string | null;
  id: number | null;
  items?: NavigationItem[];
  details?: string;
}

export interface EventPayload {
  thread_id?: string;
  url?: string;
  question_text?: string;
  created_at?: string;
  updated_at?: string;
  answer_text?: string;
  answer_id?: string;
  sources?: string[];
  generation_time_ms?: number;
  vote?: number;
  vehicle_brand?: string;
  trigger_type?: string;
  feedback_text?: string;
  car_type_id?: number;
  k_type_id?: number;
  vin?: string;
  kba?: string;
  manual?: boolean;
  hp_make_id?: number;
  hp_model_id?: number;
  /** @format date-time */
  deleted_at?: string;
  code_id?: string;
  code_redeemed?: boolean;
  cancelled_date?: string;
  cancellation_reversal_date?: string;
  last_logout_at?: string;
  account_deleted_at?: string;
  content_filter_triggered?: boolean;
  answer_found_to_question?: boolean;
  qira_system?: object;
}

export interface EventData {
  kind: QiraEventKind;
  event_source?: string;
  environment?: string;
  company_id?: string;
  user_id?: string;
  payload: EventPayload;
}

export interface QiraEventLegacy {
  event: EventData;
}

export interface QiraEvent {
  eventCode: object;
  userId?: string;
  payload: object;
}

export interface HpArticle {
  text: string;
}

export interface SuccessResponseDto {
  /**
   * Indicates if the operation was successful
   * @example true
   */
  success: boolean;
}

export interface EnhancedProductDto {
  /** extends Stripe Product */
  productPrices: string[];
}

export interface HpPoint {
  xvalue: number;
  yminvalue: number;
  ymaxvalue: number;
}

export interface HpGraph {
  xaxis: string | null;
  yaxis: string | null;
  points: HpPoint[];
}

export interface HpRow {
  value1: string | null;
  value2: string | null;
}

export interface HpTable {
  header: HpRow | null;
  rows: HpRow[] | null;
}

export type HpDiagramToolParameters = object;

export interface HpDiagnosisStepV3 {
  flashVarsString: string | null;
  graph: HpGraph | null;
  name: string | null;
  noAnswer: HpDiagnosisStepV3 | null;
  scopeImagesPaths: string[] | null;
  sortOrder: number | null;
  table: HpTable | null;
  text: string | null;
  title: string | null;
  toolParameters: HpDiagramToolParameters | null;
  type: object;
  wirediagramLink: string | null;
  yesAnswer: HpDiagnosisStepV3 | null;
}

export interface HpWizardV3 {
  diagnosisSteps: HpDiagnosisStepV3[] | null;
  title: string | null;
}

export type HpGenericPart = object;

export type HpLinkedStoriesV2 = object;

export interface HpComponentWsV2 {
  name: string | null;
  description: string | null;
  pinName: string | null;
  wireColor1: string | null;
  wireColor2: string | null;
  hyperlink: boolean | null;
  si: number | null;
  st: number | null;
  pinNumber: string | null;
  supplied: boolean | null;
  voltage: string | null;
}

export interface HpPinsArrayV2 {
  componentsArray: HpComponentWsV2[];
}

export interface HpSmartLink {
  operation: string | null;
  text: object[] | null;
  id1: number;
  id2: string | null;
  filter: string | null;
}

export interface HpCompleteComponentV10 {
  componentCode: string | null;
  componentDescription: string | null;
  componentImageId: number | null;
  connectorSideImage: string | null;
  diagnosisSteps: HpWizardV3[] | null;
  ecuSideImage: string | null;
  genericParts: HpGenericPart[] | null;
  hasLocationSystems: boolean | null;
  linkedStories: HpLinkedStoriesV2[] | null;
  localWiringImageConcise: string | null;
  localWiringImageExtended: string | null;
  pinTable: HpPinsArrayV2 | null;
  pinTableExtended: HpPinsArrayV2 | null;
  renderable: boolean | null;
  smartLinks: HpSmartLink[] | null;
  symbolInstance: string | null;
}

export interface CompleteComponentListItem {
  component: HpCompleteComponentV10;
  title: string;
}

export interface AffectedDiagnostic {
  /** List of complete components */
  completeComponentList: CompleteComponentListItem[];
  text: string;
}

export interface HpVesaSystem {
  system_type_id: number;
  text: string | null;
}

export interface HpSystemGroup {
  sg_number: number | null;
  system_group_id: number | null;
  systems: HpVesaSystem[] | null;
  text: string | null;
}

export interface VariantGroup {
  mainGroup: string | null;
  systemGroups: HpSystemGroup[] | null;
  system_group_id: number;
  system_group_number: number | null;
  systems: HpVesaSystem[] | null;
  text: string | null;
}

export interface HpGeneralArticle {
  description: string | null;
  id: number | null;
  mandatory: boolean;
}

export interface HpComponentNotFullV2 {
  generalArticles: HpGeneralArticle[] | null;
  loDirection: string | null;
  loX: number | null;
  loY: number | null;
  name: string | null;
  number: string | null;
  shieldPinId: number | null;
  slImagesId: number | null;
  symbolInstanceId: number | null;
  systemTypeId: number | null;
}

export interface HpDiagnosticComponentV2 {
  component: HpComponentNotFullV2 | null;
  couplingType: number;
  system_group_id: number;
  system_type_id: number;
  systemName?: string | null;
}

export interface VariantGroupsWithComponents {
  variantGroups: VariantGroup[];
  diagnosticComponents: HpDiagnosticComponentV2[] | null;
}

export interface GetWiringDiagramComponentsDTO {
  carTypeId: number;
  componentIds: number[];
}

export interface ElasticEntry {
  elasticsearch_id: string;
  repair_group_number: string;
  main_chapter_id: string;
  chapter_id: string;
  repair_group_title: string;
  main_chapter_title: string;
  chapter_title: string;
  full_title: string;
  file_name: string;
  folder_name: string;
  chapter_json: string;
  xml_document_id: string;
  print_number: string;
  transmission_type: string;
  engine_codes: string;
  type_description: string;
  sales_type: string;
  language: string;
}

export interface WDElasticEntry {
  elasticsearch_id: string;
  wd_group_number: string;
  wd_group_title: string;
  full_title: string;
  file_name: string;
  folder_name: string;
  chapter_json: string;
  xml_document_id: string;
  print_number: string;
  transmission_type: string;
  engine_codes: string;
  type_description: string[];
  sales_type: string;
  model_year: string;
  language: string;
}

export interface SkodaElasticEntry {
  elasticsearch_id: string;
  repair_group_number: string;
  main_chapter_id: string;
  chapter_id: string;
  repair_group_title: string;
  main_chapter_title: string;
  chapter_title: string;
  full_title: string;
  file_name: string;
  folder_name: string;
  chapter_json: string;
  xml_document_id: string;
  print_number: string;
  transmission_type: string;
  engine_codes: string;
  type_description: string;
  sales_type: string;
  language: string;
}

export interface SeatElasticEntry {
  elasticsearch_id: string;
  repair_group_number: string;
  main_chapter_id: string;
  chapter_id: string;
  repair_group_title: string;
  main_chapter_title: string;
  chapter_title: string;
  full_title: string;
  file_name: string;
  folder_name: string;
  chapter_json: string;
  xml_document_id: string;
  print_number: string;
  transmission_type: string;
  engine_codes: string;
  type_description: string;
  sales_type: string;
  language: string;
}

export interface AudiElasticEntry {
  elasticsearch_id: string;
  repair_group_number: string;
  main_chapter_id: string;
  chapter_id: string;
  repair_group_title: string;
  main_chapter_title: string;
  chapter_title: string;
  full_title: string;
  file_name: string;
  folder_name: string;
  chapter_json: string;
  xml_document_id: string;
  print_number: string;
  transmission_type: string;
  engine_codes: string;
  type_description: string;
  sales_type: string;
  language: string;
}

export interface TeslaEntry {
  url: string;
  guid: string;
  tesla_entry_id: string;
  main_section_name: string;
  main_section_id: number;
  sub_section_name: string;
  sub_section_id: number;
  issue_page_name: string;
  breadcrumb: string;
  correction_code: string;
  content: string;
  model: string;
  model_year: string;
}

export interface ServiceHealthStatus {
  /** @example "green" */
  status: "green" | "yellow" | "red";
  /** @example "HaynesProApiClientService" */
  name: string;
}

export interface ImageFileDto {
  /**
   * An image file
   * @format binary
   */
  image: File;
}

export interface VartaVehicleInformation {
  name: string;
  details: {
    modeltype: string;
    manufacturer: string;
    kw: string;
    ps: string;
    label: string;
    startStopOnly: object;
    hasStartStopOption: object;
    hasConventionalOption: object;
    hasComplexityOption: object;
    hasDiagnosticOption: object;
    constructionYearFrom: number;
    constructionYearTo: number;
  };
}

export interface VartaPDF {
  eobd_location: string | null;
  battery_location: string | null;
}

export interface VartaBatteryDetails {
  article_no: string;
  type_no: number;
  productline_no: number;
  productline_no_orig: number;
  article_status: string;
  uk_no: string;
  id: number;
  short_code: string;
  etn: string;
  productline: string;
  brand_no: number;
  recommendation: object;
  upgrade: object;
  alternative: object;
  auxiliary: object;
  startstop: object;
  conventional: object;
  complexityindicator: object;
  diagnosticmarker: object;
  api_status_label: object;
  ah: string;
  cca: string;
  voltage: string;
  width: number;
  height: number;
  length: number;
  mounting_angle: number | null;
  mounting_upright: number | null;
  case_size: string;
  meta_code: number | null;
}

export interface VartaKeyBenefit {
  textNo: number;
  shortText: string;
  text: string;
  sortOrder: number;
  title: string;
  iconUrl: string;
}

export interface VartaDrawing {
  name: string;
  type: object;
  image: string;
}

export interface VartaBattery {
  details: VartaBatteryDetails;
  image: string;
  thumbnails: string[];
  keybenefits: VartaKeyBenefit[];
  drawings: VartaDrawing[];
  productsheet: string;
}

export interface VartaVehiclePositionInformation {
  statusCode: number;
  message: string;
}

export interface VartaBatteryReplacementInformation {
  statusCode: number;
  message: string;
}

export interface VartaData {
  permission: object[];
  description: string;
  vehicleInformations: VartaVehicleInformation;
  pdf: VartaPDF;
  batteries: VartaBattery[];
  vehiclePositionInformations: VartaVehiclePositionInformation;
  batteryReplacementInformations: VartaBatteryReplacementInformation;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      return data;
    });
  };
}

/**
 * @title QIRA API
 * @version 1.0
 * @contact
 *
 * API Documentation for QIRA
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags BackofficeAuth
   * @name RedirectToBackoffice
   * @request GET:/
   */
  redirectToBackoffice = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/`,
      method: "GET",
      ...params,
    });

  auth = {
    /**
     * No description
     *
     * @tags Auth / SSO
     * @name Login
     * @request GET:/auth/ahead/login
     */
    login: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/ahead/login`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth / SSO
     * @name Initiate
     * @request GET:/auth/ahead/initiate
     */
    initiate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/ahead/initiate`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth / SSO
     * @name Callback
     * @request GET:/auth/ahead/callback
     */
    callback: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/ahead/callback`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth / SSO
     * @name Me
     * @request GET:/auth/ahead/me
     */
    me: (params: RequestParams = {}) =>
      this.request<QiraUserBE, any>({
        path: `/auth/ahead/me`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth / SSO
     * @name UpdateUser
     * @request PATCH:/auth/ahead/user
     */
    updateUser: (data: UpdateUserDto, params: RequestParams = {}) =>
      this.request<Object, any>({
        path: `/auth/ahead/user`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth / SSO
     * @name Logout
     * @request GET:/auth/ahead/logout
     */
    logout: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/ahead/logout`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuthCodes
     * @name GenerateCode
     * @request POST:/auth/ahead/code/generate
     */
    generateCode: (data: GenerateCodeDto, params: RequestParams = {}) =>
      this.request<UserCode, any>({
        path: `/auth/ahead/code/generate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuthCodes
     * @name ListCodes
     * @request GET:/auth/ahead/code/list
     */
    listCodes: (params: RequestParams = {}) =>
      this.request<UserCode[], any>({
        path: `/auth/ahead/code/list`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuthCodes
     * @name LoginWithCode
     * @request POST:/auth/ahead/code/login
     */
    loginWithCode: (data: LoginWithCodeDto, params: RequestParams = {}) =>
      this.request<LoginWithCodeResponseDto, any>({
        path: `/auth/ahead/code/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuthCodes
     * @name DeactivateCode
     * @request POST:/auth/ahead/code/deactivate
     */
    deactivateCode: (data: DeactivateCodeDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/ahead/code/deactivate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuthCodes
     * @name HideCode
     * @request POST:/auth/ahead/code/hide
     */
    hideCode: (data: HideCodeDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/ahead/code/hide`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  accounts = {
    /**
     * No description
     *
     * @tags Account
     * @name DeleteCompany
     * @request DELETE:/accounts/{id}
     * @secure
     */
    deleteCompany: (
      id: string,
      query: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/accounts/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
  hgs = {
    /**
     * No description
     *
     * @tags HgsPublicKey
     * @name GetPublicKey
     * @request GET:/hgs/public-key
     */
    getPublicKey: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/hgs/public-key`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HGS Documents
     * @name GetDocument
     * @request GET:/hgs/documents
     * @secure
     */
    getDocument: (
      query: {
        type: string;
        carTypeId?: number;
        carTypeGroup?:
          | "ENGINE"
          | "TRANSMISSION"
          | "STEERING"
          | "BRAKES"
          | "EXTERIOR"
          | "ELECTRONICS"
          | "QUICKGUIDES";
        location?: 5 | 4 | 1 | 2 | 3 | 6;
        storyId?: number;
        tsbType?: string;
        systemId?: number;
        errorCode?: string;
        vin?: string;
        engineCode?: string;
        mbId?: number;
        mbNumber?: string;
        mbInfoTypeCode?: number;
        daily?: boolean;
        managementSystemId?: number;
        componentId?: number;
        systemName?: string;
        componentName?: string;
        level?: Object;
        systemGroupId?: number;
        systemGroupName?: string;
        systems?: Object[];
        components?: Object[];
        chapterId?: string;
        mainChapterId?: string;
        xmlDocumentId?: string;
        repairGroupNumber?: string;
        elasticsearchId?: string;
        wdGroupNumber?: string;
        guid?: string;
        hgsDocumentId?: string;
        documentText?: string;
        hgsSystemId?: string;
        language?: string;
        docTitle?: string;
        kType?: string;
        hgsComponentId?: string;
        techDataGroupId?: string;
        recallHeadline?: string;
        country?: string;
        hgsServiceScheduleId?: number;
        parentGroupId?: string;
        parentGroupText?: string;
        grandParentGroupId?: string;
        grandParentGroupText?: string;
        mainGroupId?: string;
        subGroupId?: string;
        manualGroupId?: string;
        manualId?: string;
        qualifierId?: string;
        categoryId?: string;
        subCategoryId?: string;
        genericArticleNo?: string;
        searchTerm?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HgsArticleOld, any>({
        path: `/hgs/documents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  hgsNew = {
    /**
     * No description
     *
     * @tags HGS Documents
     * @name GetDocument
     * @request GET:/hgs-new/documents
     * @secure
     */
    getDocument: (
      query: {
        type: string;
        carTypeId?: number;
        carTypeGroup?:
          | "ENGINE"
          | "TRANSMISSION"
          | "STEERING"
          | "BRAKES"
          | "EXTERIOR"
          | "ELECTRONICS"
          | "QUICKGUIDES";
        location?: 5 | 4 | 1 | 2 | 3 | 6;
        storyId?: number;
        tsbType?: string;
        systemId?: number;
        errorCode?: string;
        vin?: string;
        engineCode?: string;
        mbId?: number;
        mbNumber?: string;
        mbInfoTypeCode?: number;
        daily?: boolean;
        managementSystemId?: number;
        componentId?: number;
        systemName?: string;
        componentName?: string;
        level?: Object;
        systemGroupId?: number;
        systemGroupName?: string;
        systems?: Object[];
        components?: Object[];
        chapterId?: string;
        mainChapterId?: string;
        xmlDocumentId?: string;
        repairGroupNumber?: string;
        elasticsearchId?: string;
        wdGroupNumber?: string;
        guid?: string;
        hgsDocumentId?: string;
        documentText?: string;
        hgsSystemId?: string;
        language?: string;
        docTitle?: string;
        kType?: string;
        hgsComponentId?: string;
        techDataGroupId?: string;
        recallHeadline?: string;
        country?: string;
        hgsServiceScheduleId?: number;
        parentGroupId?: string;
        parentGroupText?: string;
        grandParentGroupId?: string;
        grandParentGroupText?: string;
        mainGroupId?: string;
        subGroupId?: string;
        manualGroupId?: string;
        manualId?: string;
        qualifierId?: string;
        categoryId?: string;
        subCategoryId?: string;
        genericArticleNo?: string;
        searchTerm?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HgsArticle, any>({
        path: `/hgs-new/documents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HGS Documents
     * @name ProxyImage
     * @request GET:/hgs-new/proxy-image
     * @secure
     */
    proxyImage: (
      query: {
        /** Image ID or Diagram ID */
        id: string;
        /** Type of resource */
        type: "image" | "wiring-diagram";
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/hgs-new/proxy-image`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  vehicles = {
    /**
     * No description
     *
     * @tags Vehicles
     * @name GetMakes
     * @request GET:/vehicles/makes
     * @secure
     */
    getMakes: (params: RequestParams = {}) =>
      this.request<Manufacturer[], any>({
        path: `/vehicles/makes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name GetModels
     * @request GET:/vehicles/models/{makeId}
     * @secure
     */
    getModels: (makeId: number, params: RequestParams = {}) =>
      this.request<Model[], any>({
        path: `/vehicles/models/${makeId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name GetVehiclesByModelId
     * @request GET:/vehicles/by-model-id/{makeId}/{modelId}
     * @secure
     */
    getVehiclesByModelId: (
      makeId: number,
      modelId: number,
      params: RequestParams = {},
    ) =>
      this.request<Vehicle[], any>({
        path: `/vehicles/by-model-id/${makeId}/${modelId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name GetVehicleByCarTypeId
     * @request GET:/vehicles/by-car-type-id/{carTypeId}
     * @secure
     */
    getVehicleByCarTypeId: (carTypeId: number, params: RequestParams = {}) =>
      this.request<Vehicle, any>({
        path: `/vehicles/by-car-type-id/${carTypeId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name GetVehicleByKTypeId
     * @request GET:/vehicles/by-k-type-id/{kTypeId}/{engineCode}
     * @secure
     */
    getVehicleByKTypeId: (
      kTypeId: number,
      engineCode: string,
      params: RequestParams = {},
    ) =>
      this.request<Vehicle, any>({
        path: `/vehicles/by-k-type-id/${kTypeId}/${engineCode}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name GetVehicleFromDb
     * @request GET:/vehicles/by-db/{threadId}
     * @secure
     */
    getVehicleFromDb: (threadId: string, params: RequestParams = {}) =>
      this.request<Vehicle, any>({
        path: `/vehicles/by-db/${threadId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name GetVehicleByKba
     * @request GET:/vehicles/by-kba/{kba}
     * @secure
     */
    getVehicleByKba: (kba: string, params: RequestParams = {}) =>
      this.request<Vehicle[], any>({
        path: `/vehicles/by-kba/${kba}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name GetVehicleByVin
     * @request GET:/vehicles/by-vin/{vin}
     * @secure
     */
    getVehicleByVin: (vin: string, params: RequestParams = {}) =>
      this.request<Vehicle[], any>({
        path: `/vehicles/by-vin/${vin}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name GetVehicleByTecDoc
     * @request GET:/vehicles/by-tecdoc/{tdid}
     * @secure
     */
    getVehicleByTecDoc: (tdid: number, params: RequestParams = {}) =>
      this.request<HpWSIdentificationElement[], any>({
        path: `/vehicles/by-tecdoc/${tdid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  threads = {
    /**
     * No description
     *
     * @tags Threads
     * @name Create
     * @request POST:/threads
     * @secure
     */
    create: (data: CreateThreadDto, params: RequestParams = {}) =>
      this.request<Thread, any>({
        path: `/threads`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Threads
     * @name FindAll
     * @request GET:/threads
     * @secure
     */
    findAll: (
      query?: {
        /** Optionally include an additional thread by ID (intended for admin use). */
        additionalThreadId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ThreadWithoutMessagesDto[], any>({
        path: `/threads`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Threads
     * @name FindOne
     * @request GET:/threads/{id}
     * @secure
     */
    findOne: (id: string, params: RequestParams = {}) =>
      this.request<Thread, any>({
        path: `/threads/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Threads
     * @name Update
     * @request PATCH:/threads/{id}
     * @secure
     */
    update: (id: string, data: UpdateThreadDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/threads/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Threads
     * @name Remove
     * @request DELETE:/threads/{id}
     * @secure
     */
    remove: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/threads/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Threads
     * @name CreateMessage
     * @request POST:/threads/{id}/messages
     * @secure
     */
    createMessage: (
      id: string,
      data: CreateMessageDto,
      params: RequestParams = {},
    ) =>
      this.request<QiraMessage, any>({
        path: `/threads/${id}/messages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Threads
     * @name FindAllMessages
     * @request GET:/threads/{id}/messages
     * @secure
     */
    findAllMessages: (
      id: string,
      query?: {
        /** Return messages created after this date/time */
        created_after?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<QiraMessage[], any>({
        path: `/threads/${id}/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Threads
     * @name FindMessage
     * @request GET:/threads/{id}/messages/{messageId}
     * @secure
     */
    findMessage: (id: string, messageId: string, params: RequestParams = {}) =>
      this.request<QiraMessage, any>({
        path: `/threads/${id}/messages/${messageId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Threads
     * @name UpdateMessage
     * @request PATCH:/threads/{id}/messages/{messageId}
     * @secure
     */
    updateMessage: (
      id: string,
      messageId: string,
      data: UpdateMessageDto,
      params: RequestParams = {},
    ) =>
      this.request<QiraMessage, any>({
        path: `/threads/${id}/messages/${messageId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Threads
     * @name RemoveMessage
     * @request DELETE:/threads/{id}/messages/{messageId}
     * @secure
     */
    removeMessage: (
      id: string,
      messageId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/threads/${id}/messages/${messageId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  rmi = {
    /**
     * No description
     *
     * @tags Navigation
     * @name GetNavigation
     * @request GET:/rmi/hp/navigation/{carTypeId}
     * @secure
     */
    getNavigation: (carTypeId: number, params: RequestParams = {}) =>
      this.request<NavigationItem[], any>({
        path: `/rmi/hp/navigation/${carTypeId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mercedes
     * @name ProxyImage
     * @request GET:/rmi/mb/proxy-image
     */
    proxyImage: (
      query: {
        url: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/rmi/mb/proxy-image`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HaynesPro Documents
     * @name GetDocuments
     * @request GET:/rmi/hp/documents
     * @secure
     */
    getDocuments: (
      query: {
        type: string;
        carTypeId?: number;
        carTypeGroup?:
          | "ENGINE"
          | "TRANSMISSION"
          | "STEERING"
          | "BRAKES"
          | "EXTERIOR"
          | "ELECTRONICS"
          | "QUICKGUIDES";
        location?: 5 | 4 | 1 | 2 | 3 | 6;
        storyId?: number;
        tsbType?: string;
        systemId?: number;
        errorCode?: string;
        vin?: string;
        engineCode?: string;
        mbId?: number;
        mbNumber?: string;
        mbInfoTypeCode?: number;
        daily?: boolean;
        managementSystemId?: number;
        componentId?: number;
        systemName?: string;
        componentName?: string;
        level?: Object;
        systemGroupId?: number;
        systemGroupName?: string;
        systems?: Object[];
        components?: Object[];
        chapterId?: string;
        mainChapterId?: string;
        xmlDocumentId?: string;
        repairGroupNumber?: string;
        elasticsearchId?: string;
        wdGroupNumber?: string;
        guid?: string;
        hgsDocumentId?: string;
        documentText?: string;
        hgsSystemId?: string;
        language?: string;
        docTitle?: string;
        kType?: string;
        hgsComponentId?: string;
        techDataGroupId?: string;
        recallHeadline?: string;
        country?: string;
        hgsServiceScheduleId?: number;
        parentGroupId?: string;
        parentGroupText?: string;
        grandParentGroupId?: string;
        grandParentGroupText?: string;
        mainGroupId?: string;
        subGroupId?: string;
        manualGroupId?: string;
        manualId?: string;
        qualifierId?: string;
        categoryId?: string;
        subCategoryId?: string;
        genericArticleNo?: string;
        searchTerm?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HpArticle[], any>({
        path: `/rmi/hp/documents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HaynesPro Search Entries
     * @name GetSearchEntries
     * @request GET:/rmi/hp/search-entries
     * @secure
     */
    getSearchEntries: (
      query: {
        type: string;
        carTypeId: number;
        searchEntryId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchEntry[], any>({
        path: `/rmi/hp/search-entries`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HPWiringDiagrams
     * @name GetDiagnosisForErrorCode
     * @request GET:/rmi/hp/wiring-diagrams/diagnosisForErrorCode/{carTypeId}/{errorCode}
     * @secure
     */
    getDiagnosisForErrorCode: (
      carTypeId: number,
      errorCode: string,
      params: RequestParams = {},
    ) =>
      this.request<AffectedDiagnostic[], any>({
        path: `/rmi/hp/wiring-diagrams/diagnosisForErrorCode/${carTypeId}/${errorCode}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HPWiringDiagrams
     * @name GetVariantGroupsWithComponentsForErrorCode
     * @request GET:/rmi/hp/wiring-diagrams/variantGroupComponentsForErrorCode/{carTypeId}/{errorCode}
     * @secure
     */
    getVariantGroupsWithComponentsForErrorCode: (
      carTypeId: number,
      errorCode: string,
      params: RequestParams = {},
    ) =>
      this.request<VariantGroupsWithComponents, any>({
        path: `/rmi/hp/wiring-diagrams/variantGroupComponentsForErrorCode/${carTypeId}/${errorCode}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HPWiringDiagrams
     * @name GetComponentsByIds
     * @request POST:/rmi/hp/wiring-diagrams/getComponentsByIds
     * @secure
     */
    getComponentsByIds: (
      data: GetWiringDiagramComponentsDTO,
      params: RequestParams = {},
    ) =>
      this.request<VariantGroupsWithComponents, any>({
        path: `/rmi/hp/wiring-diagrams/getComponentsByIds`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HPWiringDiagrams
     * @name GetCompleteDiagnosticComponent
     * @request GET:/rmi/hp/wiring-diagrams/completeDiagnosticComponent/{carTypeId}/{symbolInstanceId}/{systemTypeId}
     * @secure
     */
    getCompleteDiagnosticComponent: (
      carTypeId: number,
      symbolInstanceId: number,
      systemTypeId: number,
      params: RequestParams = {},
    ) =>
      this.request<HpCompleteComponentV10, any>({
        path: `/rmi/hp/wiring-diagrams/completeDiagnosticComponent/${carTypeId}/${symbolInstanceId}/${systemTypeId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mercedes Documents
     * @name GetMbDocuments
     * @request GET:/rmi/mb/documents/html
     * @secure
     */
    getMbDocuments: (
      query: {
        type: string;
        carTypeId?: number;
        carTypeGroup?:
          | "ENGINE"
          | "TRANSMISSION"
          | "STEERING"
          | "BRAKES"
          | "EXTERIOR"
          | "ELECTRONICS"
          | "QUICKGUIDES";
        location?: 5 | 4 | 1 | 2 | 3 | 6;
        storyId?: number;
        tsbType?: string;
        systemId?: number;
        errorCode?: string;
        vin?: string;
        engineCode?: string;
        mbId?: number;
        mbNumber?: string;
        mbInfoTypeCode?: number;
        daily?: boolean;
        managementSystemId?: number;
        componentId?: number;
        systemName?: string;
        componentName?: string;
        level?: Object;
        systemGroupId?: number;
        systemGroupName?: string;
        systems?: Object[];
        components?: Object[];
        chapterId?: string;
        mainChapterId?: string;
        xmlDocumentId?: string;
        repairGroupNumber?: string;
        elasticsearchId?: string;
        wdGroupNumber?: string;
        guid?: string;
        hgsDocumentId?: string;
        documentText?: string;
        hgsSystemId?: string;
        language?: string;
        docTitle?: string;
        kType?: string;
        hgsComponentId?: string;
        techDataGroupId?: string;
        recallHeadline?: string;
        country?: string;
        hgsServiceScheduleId?: number;
        parentGroupId?: string;
        parentGroupText?: string;
        grandParentGroupId?: string;
        grandParentGroupText?: string;
        mainGroupId?: string;
        subGroupId?: string;
        manualGroupId?: string;
        manualId?: string;
        qualifierId?: string;
        categoryId?: string;
        subCategoryId?: string;
        genericArticleNo?: string;
        searchTerm?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Object, any>({
        path: `/rmi/mb/documents/html`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mercedes Documents
     * @name GetMbDocumentsPdf
     * @request GET:/rmi/mb/documents/pdf
     * @secure
     */
    getMbDocumentsPdf: (
      query: {
        type: string;
        carTypeId?: number;
        carTypeGroup?:
          | "ENGINE"
          | "TRANSMISSION"
          | "STEERING"
          | "BRAKES"
          | "EXTERIOR"
          | "ELECTRONICS"
          | "QUICKGUIDES";
        location?: 5 | 4 | 1 | 2 | 3 | 6;
        storyId?: number;
        tsbType?: string;
        systemId?: number;
        errorCode?: string;
        vin?: string;
        engineCode?: string;
        mbId?: number;
        mbNumber?: string;
        mbInfoTypeCode?: number;
        daily?: boolean;
        managementSystemId?: number;
        componentId?: number;
        systemName?: string;
        componentName?: string;
        level?: Object;
        systemGroupId?: number;
        systemGroupName?: string;
        systems?: Object[];
        components?: Object[];
        chapterId?: string;
        mainChapterId?: string;
        xmlDocumentId?: string;
        repairGroupNumber?: string;
        elasticsearchId?: string;
        wdGroupNumber?: string;
        guid?: string;
        hgsDocumentId?: string;
        documentText?: string;
        hgsSystemId?: string;
        language?: string;
        docTitle?: string;
        kType?: string;
        hgsComponentId?: string;
        techDataGroupId?: string;
        recallHeadline?: string;
        country?: string;
        hgsServiceScheduleId?: number;
        parentGroupId?: string;
        parentGroupText?: string;
        grandParentGroupId?: string;
        grandParentGroupText?: string;
        mainGroupId?: string;
        subGroupId?: string;
        manualGroupId?: string;
        manualId?: string;
        qualifierId?: string;
        categoryId?: string;
        subCategoryId?: string;
        genericArticleNo?: string;
        searchTerm?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/rmi/mb/documents/pdf`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VW
     * @name GetVwByElasticsearchId
     * @request GET:/rmi/vw/get-by-elasticsearch-id
     * @secure
     */
    getVwByElasticsearchId: (
      query: {
        elasticsearchId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ElasticEntry, any>({
        path: `/rmi/vw/get-by-elasticsearch-id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VW
     * @name GetVwById
     * @request GET:/rmi/vw/by-id
     * @secure
     */
    getVwById: (
      query: {
        wdGroupNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WDElasticEntry, any>({
        path: `/rmi/vw/by-id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VW
     * @name ProxyVolkswagenImage
     * @request GET:/rmi/vw/proxy-image
     * @secure
     */
    proxyVolkswagenImage: (
      query: {
        vehicleId: string;
        imageId: string;
        subject?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/rmi/vw/proxy-image`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Skoda
     * @name GetSkodaByElasticsearchId
     * @request GET:/rmi/skoda/get-by-elasticsearch-id
     * @secure
     */
    getSkodaByElasticsearchId: (
      query: {
        elasticsearchId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SkodaElasticEntry, any>({
        path: `/rmi/skoda/get-by-elasticsearch-id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Skoda
     * @name GetSkodaById
     * @request GET:/rmi/skoda/by-id
     * @secure
     */
    getSkodaById: (
      query?: {
        chapterId?: string;
        xmlDocumentId?: string;
        mainChapterId?: string;
        repairGroupNumber?: string;
        wdGroupNumber?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Object, any>({
        path: `/rmi/skoda/by-id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Skoda
     * @name ProxySkodaImage
     * @request GET:/rmi/skoda/proxy-image
     * @secure
     */
    proxySkodaImage: (
      query: {
        vehicleId: string;
        imageId: string;
        subject?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/rmi/skoda/proxy-image`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seat
     * @name GetSeatByElasticsearchId
     * @request GET:/rmi/seat/get-by-elasticsearch-id
     * @secure
     */
    getSeatByElasticsearchId: (
      query: {
        elasticsearchId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SeatElasticEntry, any>({
        path: `/rmi/seat/get-by-elasticsearch-id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seat
     * @name GetSeatById
     * @request GET:/rmi/seat/by-id
     * @secure
     */
    getSeatById: (
      query?: {
        chapterId?: string;
        xmlDocumentId?: string;
        mainChapterId?: string;
        repairGroupNumber?: string;
        wdGroupNumber?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Object, any>({
        path: `/rmi/seat/by-id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seat
     * @name ProxySeatImage
     * @request GET:/rmi/seat/proxy-image
     * @secure
     */
    proxySeatImage: (
      query: {
        vehicleId: string;
        imageId: string;
        subject?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/rmi/seat/proxy-image`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audi
     * @name GetAudiByElasticsearchId
     * @request GET:/rmi/audi/get-by-elasticsearch-id
     * @secure
     */
    getAudiByElasticsearchId: (
      query: {
        elasticsearchId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AudiElasticEntry, any>({
        path: `/rmi/audi/get-by-elasticsearch-id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audi
     * @name GetAudiById
     * @request GET:/rmi/audi/by-id
     * @secure
     */
    getAudiById: (
      query?: {
        chapterId?: string;
        xmlDocumentId?: string;
        mainChapterId?: string;
        repairGroupNumber?: string;
        wdGroupNumber?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Object, any>({
        path: `/rmi/audi/by-id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audi
     * @name ProxyAudiImage
     * @request GET:/rmi/audi/proxy-image
     * @secure
     */
    proxyAudiImage: (
      query: {
        vehicleId: string;
        imageId: string;
        subject?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/rmi/audi/proxy-image`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tesla
     * @name GetTeslaById
     * @request GET:/rmi/tesla/by-id
     * @secure
     */
    getTeslaById: (
      query: {
        guid: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TeslaEntry, any>({
        path: `/rmi/tesla/by-id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tesla
     * @name SearchTeslaDocuments
     * @request GET:/rmi/tesla/search
     * @secure
     */
    searchTeslaDocuments: (
      query: {
        query: string;
        model?: string;
        yearRange?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TeslaEntry[], any>({
        path: `/rmi/tesla/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tesla
     * @name ProxyTeslaImage
     * @request GET:/rmi/tesla/proxy-image
     * @secure
     */
    proxyTeslaImage: (
      query: {
        imageId: string;
        model?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/rmi/tesla/proxy-image`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  voice = {
    /**
     * No description
     *
     * @tags Voice
     * @name StreamVoice
     * @request GET:/voice/stream/{threadId}/{messageId}
     * @secure
     */
    streamVoice: (
      threadId: string,
      messageId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/voice/stream/${threadId}/${messageId}`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  eventTracker = {
    /**
     * No description
     *
     * @tags Event-Tracker
     * @name LogEvent
     * @request POST:/event-tracker/event
     */
    logEvent: (data: QiraEventLegacy, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/event-tracker/event`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  eventTrackerInternal = {
    /**
     * No description
     *
     * @tags Event-Tracker-Internal
     * @name TrackEvent
     * @summary Track a frontend event
     * @request POST:/event-tracker-internal/event-internal
     */
    trackEvent: (data: QiraEvent, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/event-tracker-internal/event-internal`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  payment = {
    /**
     * No description
     *
     * @tags Payment
     * @name Webhook
     * @request POST:/payment/webhook
     */
    webhook: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/payment/webhook`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name MissedSessions
     * @request GET:/payment/checkAllCheckouts
     */
    missedSessions: (
      query: {
        checkoutSessionId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SuccessResponseDto, any>({
        path: `/payment/checkAllCheckouts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name AllActiveProducts
     * @summary Get all active products with their prices
     * @request GET:/payment/allProducts
     */
    allActiveProducts: (params: RequestParams = {}) =>
      this.request<EnhancedProductDto[], any>({
        path: `/payment/allProducts`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name GetCustomerPortal
     * @request GET:/payment/billingPortal
     */
    getCustomerPortal: (
      query: {
        qiraCompanyId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Object, any>({
        path: `/payment/billingPortal`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  health = {
    /**
     * No description
     *
     * @tags Health
     * @name Check
     * @request GET:/health
     */
    check: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/health`,
        method: "GET",
        ...params,
      }),
  };
  callback = {
    /**
     * No description
     *
     * @tags BackofficeAuth
     * @name BackofficeCallback
     * @request GET:/callback
     */
    backofficeCallback: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/callback`,
        method: "GET",
        ...params,
      }),
  };
  backoffice = {
    /**
     * No description
     *
     * @tags BackofficeAuth
     * @name GetBackoffice
     * @request GET:/backoffice
     */
    getBackoffice: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeUsers
     * @name GetQiraBackoffice
     * @request GET:/backoffice/user
     */
    getQiraBackoffice: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/user`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeUsers
     * @name UpdateQiraUser
     * @request PATCH:/backoffice/user/update
     */
    updateQiraUser: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/user/update`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeUsers
     * @name UpdateQiraUserPost
     * @request POST:/backoffice/user/update
     */
    updateQiraUserPost: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/user/update`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeVocab
     * @name GetQiraVocabAdmin
     * @request GET:/backoffice/vocab
     */
    getQiraVocabAdmin: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/vocab`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeVocab
     * @name CreateNormalizationVocabEntry
     * @request POST:/backoffice/vocab/create
     */
    createNormalizationVocabEntry: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/vocab/create`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeVocab
     * @name UpdateNormalizationVocabEntry
     * @request POST:/backoffice/vocab/update
     */
    updateNormalizationVocabEntry: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/vocab/update`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeVocab
     * @name DeleteNormalizationVocabEntry
     * @request POST:/backoffice/vocab/delete
     */
    deleteNormalizationVocabEntry: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/vocab/delete`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeFeatureFlags
     * @name GetFeatureFlagsAdmin
     * @request GET:/backoffice/feature-flags
     */
    getFeatureFlagsAdmin: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/feature-flags`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeFeatureFlags
     * @name UpdateFeatureFlag
     * @request POST:/backoffice/feature-flags/update
     */
    updateFeatureFlag: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/feature-flags/update`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeFeatureFlags
     * @name ResetFeatureFlag
     * @request POST:/backoffice/feature-flags/reset
     */
    resetFeatureFlag: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/feature-flags/reset`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeCutoverFlags
     * @name GetCutoverFlagsAdmin
     * @request GET:/backoffice/cutover-flags
     */
    getCutoverFlagsAdmin: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/cutover-flags`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeCutoverFlags
     * @name UpdateCutoverFlag
     * @request POST:/backoffice/cutover-flags/update
     */
    updateCutoverFlag: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/cutover-flags/update`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeCutoverFlags
     * @name UpdatePrimaryStore
     * @request POST:/backoffice/cutover-flags/primary-store
     */
    updatePrimaryStore: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/cutover-flags/primary-store`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BackofficeCutoverFlags
     * @name ResetCutoverFlag
     * @request POST:/backoffice/cutover-flags/reset
     */
    resetCutoverFlag: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backoffice/cutover-flags/reset`,
        method: "POST",
        ...params,
      }),
  };
  status = {
    /**
     * No description
     *
     * @tags Status
     * @name GetStatus
     * @request GET:/status
     * @secure
     */
    getStatus: (params: RequestParams = {}) =>
      this.request<Object, any>({
        path: `/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Status
     * @name GetHealthStatus
     * @request GET:/status/health
     * @secure
     */
    getHealthStatus: (params: RequestParams = {}) =>
      this.request<ServiceHealthStatus[], any>({
        path: `/status/health`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  knowledge = {
    /**
     * No description
     *
     * @tags Knowledge
     * @name GetVwData
     * @request GET:/knowledge/vw-knowledge
     * @secure
     */
    getVwData: (
      query: {
        vehicleId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/knowledge/vw-knowledge`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  vision = {
    /**
     * No description
     *
     * @tags Vision
     * @name GetVinFromImage
     * @request POST:/vision/vinFromImage
     */
    getVinFromImage: (data: ImageFileDto, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/vision/vinFromImage`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  metrics = {
    /**
     * No description
     *
     * @tags Prometheus
     * @name Index
     * @request GET:/metrics
     */
    index: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/metrics`,
        method: "GET",
        ...params,
      }),
  };
}
